import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A1628] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Column 1 - Logo & Description */}
          <div className="space-y-4">
            <img
              src="https://static.readdy.ai/image/f30444846e2254d95b405efc135ce378/fc64d9d112bafb837964acd5916b09ef.png"
              alt="Vetuvia"
              className="h-10 w-auto"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              The income infrastructure platform for modern veterinarians.
            </p>
          </div>

          {/* Column 2 - Platform */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4] mb-4">
              Platform
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#how-it-works" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#revenue" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Revenue Streams
                </a>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Resources */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4] mb-4">
              Resources
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#faq" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Support
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Connect */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4] mb-4">
              Connect
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="https://linkedin.com/company/vetuvia" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Email Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2024 Vetuvia. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Large Brand Typography */}
      <div className="py-12 overflow-hidden">
        <div className="text-center">
          <h3 className="text-8xl lg:text-9xl font-bold text-[#4DB8D4]/10 tracking-tight">
            VETUVIA
          </h3>
        </div>
      </div>
    </footer>
  );
}
